import { authStorage } from 'storages/authStorage';
import { getErrorMessage } from 'shared/errors';

export const loadResource = async (url: string) => {
  try {
    const response = await fetch(url, {
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${authStorage.getJwtAuthParams()?.access}`,
      },
    });
    const blob = await response.blob();
    const objectURL = URL.createObjectURL(blob);

    return objectURL;
  } catch (error) {
    const errorMessage = getErrorMessage(error);

    console.error(errorMessage);
  }
};
